export default __webpack_public_path__ + "static/media/CV-JRS.a0e5e45f.pdf";